import NiceModal from "@ebay/nice-modal-react";

import Button from "../Button";
import { useNiceModal } from "../hooks/useNiceModal";
import type { BaseModalProps } from "../types";
import BaseModal from "./BaseModal";

interface ErrorModalProps extends BaseModalProps {
  text: string;
}

const ErrorModal = NiceModal.create((props: ErrorModalProps) => {
  const modalProps = useNiceModal();
  const { onClose, onOpenChange } = props;

  return (
    <BaseModal
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      title="Error occured"
      footer={
        <Button
          color="primary"
          onPress={() => {
            modalProps.onClose();
            onClose?.();
          }}
        >
          OK
        </Button>
      }
      {...modalProps}
      onClose={() => {
        modalProps.onClose();
        onClose?.();
      }}
      onOpenChange={(open) => {
        modalProps.onOpenChange(open);
        onOpenChange?.(open);
      }}
    >
      <p>{props.text}</p>
    </BaseModal>
  );
});

export default ErrorModal;
